/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

// @ts-expect-error
import * as UserActions from 'actions/UserActions';

import EntityName from './EntityName';
import OrganizationRequest from './OrganizationRequest';

interface Props {
  request: {
    inviter: any;
    organization: any;
  };
  collapsed?: boolean;
  onAccept?: (...args: Array<any>) => any;
  onReject?: (...args: Array<any>) => any;
}

class OutboundOrganizationRequest extends React.Component<Props> {
  accept = (): void => {
    UserActions.acceptOutboundRequest(this.props.request.organization.id);
    if (typeof this.props.onAccept === 'function') {
      this.props.onAccept();
    }
  };

  reject = (): void => {
    UserActions.rejectOutboundRequest(this.props.request.organization.id);
    if (typeof this.props.onReject === 'function') {
      this.props.onReject();
    }
  };

  override render(): JSX.Element {
    return (
      <OrganizationRequest
        avatarEntity={this.props.request.organization}
        accept={this.accept}
        reject={this.reject}
        collapsed={this.props.collapsed}
      >
        <div>
          {'You were invited to join '}
          <EntityName entity={this.props.request.organization} />.
        </div>
        <div className="faded">
          {'Invited by '}
          <EntityName entity={this.props.request.inviter} />
        </div>
      </OrganizationRequest>
    );
  }
}

export default OutboundOrganizationRequest;
